module.exports = __webpack_public_path__ + "static/media/logo.d12c3bc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 425
// module chunks = 0